// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import {buildClaimsQueryFromParams} from '../../shared/services/build-query';
import {buildNumber} from '../../../shared/services/build-number';
import {getClaimSummaryHeader} from './claim-summary-header';
import {translate} from '../../../shared/services/translation-service';

const colIdDisplayMap = {
    totalUnpaid: 'TOTAL_UNPAID',
    unpaidLabor: 'UNPAID_LABOR',
    unpaidLaborAdditiveExcludingPips: 'UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS',
    unpaidLaborAdditivePips: 'UNPAID_LABOR_ADDITIVES_PIPS',
    unpaidOtherCredits: 'UNPAID_OTHER_CREDITS',
    unpaidParts: 'UNPAID_PARTS',
    unpaidPartsAdditive: 'UNPAID_PARTS_ADDITIVE',
    unpaidTravel: 'UNPAID_TRAVEL'
};

const ClaimSummaryPanel = props =>
    <section className='detail-panel'>
        <header>
            <nav className='bread-crumbs'>
                {getClaimSummaryHeader(props.queryParams)}
                <FormattedMessage
                    id='CLAIM_COUNT_WITH_PARENTHESIS'
                    values={{
                        count: props.claimCount,
                        countToDisplay: buildNumber(props.claimCount)
                    }}
                />
            </nav>
            {props.queryParams.unpaidFilter &&
                <span className='filter-applied'>
                    <FormattedMessage
                        id='FILTERED_BY_COLUMN_ID'
                        values={{
                            columnId: translate(colIdDisplayMap[props.queryParams.unpaidFilter])
                        }}
                    />
                    <Link to={`/reimbursement-summary/claims?${buildClaimsQueryFromParams(props.queryParams)}`}>
                        <FormattedMessage id='REMOVE_FILTER'/>
                    </Link>
                </span>
            }
        </header>
    </section>;

ClaimSummaryPanel.displayName = 'ClaimSummaryPanel';
ClaimSummaryPanel.propTypes = {
    claimCount: PropTypes.number.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default ClaimSummaryPanel;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/components/claim-summary-panel.js